import moment from 'moment-timezone';

import { CALENDAR_VIEWS } from '../../../../resources/events/EventViewSettings';

import { getEventId, getEventResource } from '../../DragAndDropGrid';
import { getDays } from './week';

const getMonthDates = (startDate, timezone) => {
  const dates = [];
  const date = moment.tz(startDate, timezone);
  const calendarEnd = moment.tz(startDate, timezone).endOf('week').endOf('month').endOf('week').endOf('day')

  do {
    dates.push(date.format('YYYY-MM-DD'))
    date.add(1, 'day');
  } while (date.isBefore(calendarEnd));

  return dates;
}

export const buildMonthCalendarColumns = ({
  filterValues,
  timezone,
  selectedGame,
  getAlert,
}) => {
  const { start, type } = getDays(filterValues);
  const header = moment(start).endOf('week').format('MMMM YYYY');

  const dates = type === CALENDAR_VIEWS.MONTH ? getMonthDates(start, timezone) : [];

  const rows = [];
  const totalWeeks = dates.length / 7;
  for (let i = 0; i < totalWeeks; i++) {
    rows.push(dates.slice(i * 7, (i + 1) * 7));
  }

  const values = dates.slice(0, 7).map(date => moment.tz(date, timezone).format('ddd'));

  return {
    header,
    disabled: false,
    alert: getAlert(values),
    columns: values,
    totalColumns: 7,
    rows,
    dates,
    start: selectedGame?.date,
    toEventDetails: (item, eventResource, eventId) => {
      const { x: itemColumn, y: itemRow } = item;
      const resource = eventResource || getEventResource(item);
      const id = eventId || getEventId(item);
      const date = rows?.[itemRow]?.[itemColumn];

      return {
        id,
        resource,
        date,
        startTime: null,
        endTime: null,
      };
    },
    filterEvents: events => {
      if (!selectedGame) return [];
      const teamIds = [selectedGame.homeTeamId, selectedGame.awayTeamId].filter(Boolean);
      if (!teamIds.length) return [];

      return events.filter(event => {
        return (
          (event.homeTeamId && teamIds.includes(event.homeTeamId)) ||
          (event.awayTeamId && teamIds.includes(event.awayTeamId)) ||
          (event.teamIds && event.teamIds.some(id => teamIds.includes(id)))
        );
      });
    },
    getColumnKey: () => {},
    getColumnIndex: () => {},
    getColumnHeading: () => 'Heading',
    onNext: () => {},
    onBack: () => {},
  };
};
